/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Rails_Platforms_MoreInputs */

const en_directory_rails_platforms_more = /** @type {(inputs: Directory_Rails_Platforms_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} more`)
};

const zh_directory_rails_platforms_more = /** @type {(inputs: Directory_Rails_Platforms_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`展开 ${i?.count} 个`)
};

/**
* | output |
* | --- |
* | "{count} more" |
*
* @param {Directory_Rails_Platforms_MoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_platforms_more = /** @type {((inputs: Directory_Rails_Platforms_MoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Platforms_MoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_platforms_more(inputs)
	return zh_directory_rails_platforms_more(inputs)
});
export { directory_rails_platforms_more as "directory.rails.platforms_more" }